<template>
  <div class="wrapper" style="background-color: #ffffff">
    <!-- Pricing 4 -->
    <div class="section">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-large-size-100 text-center">
            <img src="atb.png" alt="" />
          </div>
        </div>
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-100 justify-content-center mx-auto text-center"
          >
            <h2 class="title">
              Hörmətli <br />
              Xalid Əliyev, <br />
              Sizə uyğun KREDIT paketini seçin
            </h2>
            <h3 class="description title">Təyinatından asılı olaraq</h3>
            <h4 class="title">Kredit məbləği ₼30 000 qədər</h4>
          </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-button
              class="md-warning"
              style="width: 100%"
              @click="smallAlert2 = true"
            >
              <h4>Mənim <b>KREDIT</b> almaq istəyim yoxdur</h4>
            </md-button>

            <div class="modal modal-bg" :class="{ show: smallAlert2 }">
              <modal
                v-if="smallAlert2"
                type="modal-small"
                @close="smallAlert2 = false"
              >
                <template slot="header">
                  <md-button
                    class="md-simple md-close md-just-icon md-round modal-default-button"
                    @click="smallAlert2 = false"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <h3>
                    Ehitiyac yaransa bizə müraciət edin! <br />
                    Xoş günlər. <br />
                    Təşəkkür edirik!
                  </h3>
                </template>

                <template slot="footer">
                  <div class="justify-content-center d-flex">
                    <md-button
                      @click="smallAlert2 = false"
                      class="md-success md-simple"
                    >
                      Bağla
                    </md-button>
                  </div>
                </template>
              </modal>
            </div>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100 text-center">
             <h4> Seçiminizi edin və TƏSDİQ düyməsini sıxın</h4>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <a @click="onSelect(1)" style="cursor: pointer">
              <pricing-card
                :card-bg="selected === 1 ? 'success' : ''"
                :card-plain="selected !== 1"
              >
                <template slot="cardContent">
                  <h6 class="card-category text-gray" style="font-size: 20pt">
                    MƏİŞƏT
                  </h6>
                  <h1 class="card-title"><small>₼</small>10 000</h1><h3>qədər</h3>
                  <ul>
                    <li>İllik faiz dərəcəsi: 16 %</li>
                    <li>
                      <md-icon class="text-success"> check </md-icon> Smartfon, planşet, kompüter
                    </li>
                    <li>
                      <md-icon class="text-success"> check </md-icon> Mebel
                    </li>
                    <li>
                      <md-icon class="text-success"> check </md-icon> Ev məişət texnikası
                    </li>
                  </ul>

                  <md-button
                  href="javascript:void(0)"
                  class="md-default md-raised md-round" :class="selected === 1 ? 'disabled' : ''"
                  @click="onSelect(1)"
                >
                  SEÇ
                </md-button>
                </template>
              </pricing-card>
            </a>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <a @click="onSelect(2)" style="cursor: pointer">
              <pricing-card
                :card-bg="selected === 2 ? 'success' : ''"
                :card-plain="selected !== 2"
              >
                <template slot="cardContent">
                  <h6 class="card-category text-gray" style="font-size: 20pt">
                    NÖVBƏTİ
                  </h6>
                  <h1 class="card-title"><small>₼</small>20 000</h1><h3>qədər</h3>
                  <ul>
                    <li>İllik faiz dərəcəsi: 14 %</li>
                    <li>
                      <md-icon class="text-success"> check </md-icon> Avtomobil
                    </li>
                    <li>
                      <md-icon class="text-success"> check </md-icon> Ev təmiri
                    </li>
                    <li>
                      <md-icon class="text-success"> check </md-icon> Xeyir iş
                    </li>
                  
                  </ul>

                  <md-button
                @click="onSelect(2)"
                  href="javascript:void(0)"
                  class="md-default md-round md-raised" :class="selected === 2 ? 'disabled' : ''"
                >
                  SEÇ
                </md-button>
                </template>
              </pricing-card>
            </a>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <a @click="onSelect(3)" style="cursor: pointer">
              <pricing-card
                :card-bg="selected === 3 ? 'success' : ''"
                :card-plain="selected !== 3"
              >
                <template slot="cardContent">
                  <h6 class="card-category text-gray" style="font-size: 20pt">
                    BİZNES
                  </h6>
                  <h1 class="card-title"><small>&#8380;</small>30 000</h1><h3>qədər</h3>
                  <ul>
                    <li>İllik faiz dərəcəsi: 12 %</li>
                    <li>
                      <md-icon class="text-success"> check </md-icon> İnkişaf
                    </li>
                    <li>
                      <md-icon class="text-success"> check </md-icon> Layihə
                    </li>
                    <li>
                      <md-icon class="text-success"> check </md-icon> İnvestisiya
                    </li>
                  </ul>
                  <md-button
                @click="onSelect(3)"
                  href="javascript:void(0)"
                  class="md-default md-round md-raised" :class="selected === 3 ? 'disabled' : ''"
                >
                  SEÇ
                </md-button>
                </template>
              </pricing-card>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- end Pricing 4 -->
    <div class="sticky-ordernow" v-if="selected > 0">
      <div :class="!smallAlert ? 'play' : ''">
        <!-- YEKUN: {{selectedname}} paketi -->
        <md-button class="md-primary" @click="smallAlert = true">
          <md-icon>thumb_up_alt</md-icon>
          Təsdiq <br />
          {{ selectedname }} &nbsp; paketi
        </md-button>
      </div>
      <div class="modal modal-bg" :class="{ show: smallAlert }">
        <modal v-if="smallAlert" type="modal-small" @close="smallAlert = false">
          <template slot="header">
            <md-button
              class="md-simple md-close md-just-icon md-round modal-default-button"
              @click="smallAlert = false"
            >
              <md-icon>clear</md-icon>
            </md-button>
          </template>

          <template slot="body">
            <h3>Seçiminizə görə təşəkkür edirik!</h3>
            <h5><b>Yaxın dəqiqələr sizə geridönüş edəcəyik</b></h5>
          </template>

          <template slot="footer">
            <div class="justify-content-center d-flex">
              <md-button
                @click="smallAlert = false"
                class="md-success md-simple"
              >
                Bağla
              </md-button>
            </div>
          </template>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import { PricingCard, Modal } from "@/components";

export default {
  name: "Atb",
  components: {
    PricingCard,
    Modal,
  },
  data() {
    return {
      smallAlert: false,
      smallAlert2: false,
      selected: 0,
      personal: true,
      selectedname: "Qənayət",
      packages: ["MƏİŞƏT", "NÖVBƏTİ", "BİZNES"],
    };
  },
  methods: {
    onSelect(id) {
      this.selected = id;
      this.selectedname = this.packages[id - 1];
    },
    sectionPricing(image) {
      return {
        backgroundImage: `url(${image})`,
      };
    },
    changePrices() {
      this.personal = !this.personal;
    },
    onSubmit() {},
  },
};
</script>

<style lang="css">
.sticky-ordernow {
  position: fixed;
  right: 30px;
  bottom: 10px;
  z-index: 1000000;
}
.play {
  /* width: 80px;
			height: 80px; */
  background: #9c27b0;
  /* border-radius: 50%; */
  color: #fff;
  text-align: center;
  /* line-height: 80px; */
  animation: animate 3s linear infinite;
  cursor: pointer;
}
@keyframes animate {
  0% {
    box-shadow: 0 0 0 0 rgba(224, 67, 255, 0.7);
  }
  40% {
    box-shadow: 0 0 0 20px rgba(255, 26, 67, 0);
  }
  80% {
    box-shadow: 0 0 0 20px rgba(255, 206, 67, 0);
  }
  100% {
    box-shadow: 0 0 0 rgba(255, 206, 67, 0);
  }
}
</style>
